import { Tenant } from '../tenant/tenant';
import { EboNameObject } from './ebo-name-object';

export class EboTenantItem extends EboNameObject {
  tenantID: string;
  tenant: Tenant;

  constructor(jsonData: Partial<EboTenantItem>) {
    super(jsonData);
    if (jsonData) {
      // ** Create complex objects
      if (jsonData.tenant) this.tenant = new Tenant(jsonData.tenant);
    }
  }
}
